import { AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useInfiniteQuery } from '@tanstack/react-query';
import { ICollection } from '@types';

async function getCollectionList(params: {
  pageParam: number;
  query?: string;
}): Promise<AxiosResponse<FetchResult<ICollection[]>>> {
  const response = await instance.get(
    params.query && params.query.length > 0
      ? `/collections?page=${params.pageParam}&take=10${params.query}`
      : `/collections?page=${params.pageParam}&take=10`
  );
  return response;
}

const useFetchCollectionList = (needFetch: boolean, query?: string) => {
  const {
    data,
    fetchNextPage,
    fetchPreviousPage,
    hasNextPage,
    hasPreviousPage,
    isFetchingNextPage,
    isFetchingPreviousPage,
    promise,
    isLoading,
    isFetching,
    ...result
  } = useInfiniteQuery({
    queryKey: ['get', `/collections${query}`],
    queryFn: ({ pageParam }) => getCollectionList({ pageParam, query }),
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => {
      if (lastPage.data.meta && lastPage.data.meta.hasNextPage) {
        return lastPage.data.meta.page + 1;
      } else {
        return null;
      }
    },
    retry: false,
    refetchOnWindowFocus: false,
    enabled: needFetch
  });

  return {
    data,
    fetchNextPage,
    fetchPreviousPage,
    hasNextPage,
    hasPreviousPage,
    isFetchingNextPage,
    isFetchingPreviousPage,
    promise,
    isLoading,
    isFetching,
    ...result
  };
};

export default useFetchCollectionList;
